module.exports = __webpack_public_path__ + "img/d.3e3ecb39.jpg";